import { render, staticRenderFns } from "./RelevanceTrial.vue?vue&type=template&id=163da6e6"
import script from "./RelevanceTrial.vue?vue&type=script&lang=js"
export * from "./RelevanceTrial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports